import { render, staticRenderFns } from "./WorkflowTableValue.vue?vue&type=template&id=ddac47b2"
import script from "./WorkflowTableValue.vue?vue&type=script&lang=js"
export * from "./WorkflowTableValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports